import { fetchExchangeRate } from '@shared/services/ms'
import { useWss } from '@shared/stores/wss'

export async function convertPrincipalAmountToUSD(currencyCode, isBuy) {
  if (
    useWss().getExchangeRate == null ||
    !Object.hasOwn(useWss().getExchangeRate, 'USD') ||
    !Object.hasOwn(useWss().getExchangeRate, currencyCode)
  ) {
    return getUsdConversionRate(currencyCode, isBuy)
  }
  return (
    Number(useWss().getExchangeRate['USD'].split('|')[4]) /
    Number(useWss().getExchangeRate[currencyCode].split('|')[4])
  )
}

async function getUsdConversionRate(currencyCode, isBuy) {
  const [getCurrencyQuote, getCurrencyQuoteUSD] = await Promise.allSettled([
    fetchExchangeRate(currencyCode),
    fetchExchangeRate('USD')
  ])
  const payload = getCurrencyQuote.value?.data.payload
  const payloadUSD = getCurrencyQuoteUSD.value?.data.payload
  const fc = Number(isBuy ? payload?.buyPrice : payload?.sellPrice)
  const dollar = Number(isBuy ? payloadUSD?.buyPrice : payloadUSD?.sellPrice)
  return dollar / fc
}
